import { throttle } from './common';

const DEFAULT_DATA_SRC = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAjVBMVEUAAAC/v7+/v7+/v7+/v7+/v7+/v7+/v7/AwMC/v7+/v7+/v7+/v7++vr6/v7+/v7+/v7+/v7/AwMC9vb2/v7/AwMC/v7+/v7/BwcG/v7+/v7+/v7/AwMC+vr7AwMC/v7+/v7+/v7+/v7+/v7/CwsK/v7+/v7+/v7+/v7+/v7+/v7/BwcHAwMC/v7+/v78mUr/FAAAALnRSTlMAQL/7Vinl182NYl00HsevqZtSC6OJeUUQ8tOVkW9pPuzhtX8U3KGBSRouJHI5FiyTTgAAAf1JREFUaN7t09l2qkAQBdDDKKNMAioqznFI6v8/7y40LhCJGtu6een93PRZfYqCJEmSJEnS35sS9V3wWlNlWYKTQmcrMPJGdBaA0Qd9i8AiKafBMjTpx8b2CYQtqaZpGqVoUWlQQoxBbdbENdDgENF46kNATF3U5qVbqgxi3OV9ObZq9cyR1tvOvPbMx9RlVF/qW3SyCKcGuq3TBV3rt/pQKnEWbtrndJwNQ7rYRPoQ1xLvo6dRl/n25rBON4ISZ/bVt1ZQZK6y051pNlFNukvNDq2MWxnO3DG9zAxXsXEaW0Td8kvrNokZW3fejIs8IC4D1MpIIxY5mozUpPewo3pmLlrWTvCe5+ifFlVU20eH46dK4vo7JP5BSfAjz7GXG4EAOx7iOcMv54Xt0Qp9j1/5dW/z1ADAGzLZA8whGx3gDhn44A6Zz/Cigp61POBVLj0pw+uO9JTeDiKe2sbgCCETeiyFoPxxVQ5EKfTIjC+jtmDMqP2PjBV/Ri+HEIMe0tKhYMaIHgk9COrTfVbmQZR3pyQr/HANvMGKb/tqO+rUL0q80aD9s8YJGKyVWTiimjlwfLDQiwU1bHOwSByVGmwwUaJGbSm4+JM6JQYbvUffzARs9lG9joxcrZ49H2VOlQisjNPSBOA1rMavgptFVIBdn3Lw8yFJkiRJknTyDxB2YJ9W4jesAAAAAElFTkSuQmCC';
const preLoadHeight = 100;

const firstScreenLoad = () => {
    const seeHeight = document.documentElement.clientHeight; //可见区域高度

    const imgList = document.querySelectorAll("img[data-src]");
    const imgNum = imgList.length;
    if (imgNum === 0) {
        return;
    }

    for (let i = 0; i < imgNum; i++) {

        const imgToTop = imgList[i].getBoundingClientRect().top;

        if (imgToTop - preLoadHeight < seeHeight) {
            if (imgList[i].getAttribute("src") == DEFAULT_DATA_SRC) {
                imgList[i].src = imgList[i].getAttribute("data-src");
                imgList[i].removeAttribute("data-src");
            }
        }
    }
}

const startImgListener = (firstLoadTime = 1000, ignoreEvent = false) => {

    const seeHeight = document.documentElement.clientHeight; //可见区域高度

    function lazyload(event) {

        const imgList = document.querySelectorAll("img[data-src]");
        const imgNum = imgList.length;
        if (imgNum === 0) {
            return;
        }

        for (let i = 0; i < imgNum; i++) {

            const imgToTop = imgList[i].getBoundingClientRect().top;

            if (imgToTop - preLoadHeight < seeHeight) {
                if (imgList[i].getAttribute("src") == DEFAULT_DATA_SRC) {
                    imgList[i].src = imgList[i].getAttribute("data-src");
                    imgList[i].removeAttribute("data-src");
                }
            }
        }
    }
    if (!ignoreEvent) {
        window.addEventListener('scroll', throttle(lazyload, 500), true);
    }
    setTimeout(() => { lazyload() }, firstLoadTime);
}

export {
    DEFAULT_DATA_SRC,
    startImgListener,
    firstScreenLoad,
}